import { css } from "@emotion/react";
import * as React from "react";

import { useTable2ColumnPadding } from "./Table2ColumnPaddingContext";
import { useTable2RowKind } from "./Table2Row";

interface Table2ColumnProps {
    colspan?: number;
    horizontalAlign?: "center" | "left" | "right";
    children: React.ReactNode[];
}

export function Table2Column(props: Table2ColumnProps): JSX.Element {
    const padding = useTable2ColumnPadding();
    const rowKind = useTable2RowKind();

    if (rowKind === "head") {
        return (
            <th style={{ textAlign: props.horizontalAlign }} css={css({ padding: padding })} colSpan={props.colspan}>
                {props.children}
            </th>
        );
    }
    return (
        <td css={css({ padding: padding, textAlign: props.horizontalAlign })} colSpan={props.colspan}>
            {props.children}
        </td>
    );
}
